<template>
  <div
    v-if="!isSelectVisible"
    data-test="timezone-selector-label"
    class="text-body-2-black-tints-400 cursor-pointer"
  >
    <div
      data-test="timezone-selector-clickable"
      class="cursor-pointer hover:underline text-body-r-14-20 mb-1"
      @click="isSelectVisible = true"
    >
      UTC {{ currentTimezoneOffset }}
    </div>
  </div>
  <div
    v-else
    data-test="timezone-selector-select"
  >
    <wui-select
      v-model="currentTimezone"
      v-click-outside="onOutsideClick"
      :size="32"
      :items="TIMEZONES"
    />
  </div>
</template>

<script setup lang="ts">
import { WuiSelect, ClickOutside as vClickOutside } from '@wui/common-library'
import { ref } from 'vue'

import { TIMEZONES } from '../constants'
import { useTimezoneSelector } from '../model'

const isSelectVisible = ref(false)

const onOutsideClick = () => {
  isSelectVisible.value = false
}

const { currentTimezone, currentTimezoneOffset } = useTimezoneSelector()
</script>
